var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"icon":"","dark":""},on:{"click":_vm.onClick}},[_c('v-icon',{attrs:{"medium":""}},[_vm._v(_vm._s(_vm.icon))]),_vm._v("\n    "+_vm._s(_vm.text)+"\n  ")],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-01b9eb07","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/maxextentbutton/ZoomToMaxExtentButton.vue
// module id = 6jvY
// module chunks = 1